const forceProd = false

const isPollux = window.location.hostname.includes('pollux')
const isCastor = window.location.hostname.includes('castor')
const isDev =
  (window.location.hostname.includes('develop') ||
    window.location.hostname.includes('andromeda')) &&
  !forceProd
const isBeta = window.location.hostname.includes('beta') && !forceProd
const isProd = !isDev && !isBeta && (window.location.hostname.includes('orionx.') || forceProd)

export default () => {
  if (isPollux) return 'pollux'
  if (isCastor) return 'castor'
  if (isDev) return 'dev'
  if (isBeta) return 'beta'
  if (isProd) return 'prod'

  return 'local'
}
